'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../../01.atoms/Icon/Icon.js');
require('../../01.atoms/Avatar/Avatar.js');
require('../../01.atoms/Banner/Banner.js');
require('../../01.atoms/ButtonCta/ButtonCta.js');
require('../../01.atoms/ButtonLink/ButtonLink.js');
var MaterialDrop = require('../../01.atoms/MaterialDrop/MaterialDrop.js');
require('../../01.atoms/ButtonPlain/ButtonPlain.js');
require('../../01.atoms/CategoryTitle/CategoryTitle.js');
require('../../01.atoms/Checkbox/Checkbox.js');
require('../../01.atoms/ColorStripe/ColorStripe.js');
require('moment');
require('../../01.atoms/Date/Date.js');
require('../../01.atoms/Divider/Divider.js');
require('../../01.atoms/ErrorNotice/ErrorNotice.js');
require('../../01.atoms/Expandable/Expandable.js');
require('../../01.atoms/HeaderSimple/HeaderSimple.js');
require('../../01.atoms/Headline/Headline.js');
require('../../01.atoms/Img/Img.js');
require('../../01.atoms/InfoNotice/InfoNotice.js');
require('../../01.atoms/ListItem/ListItem.js');
require('../../01.atoms/LoaderContent/LoaderContent.js');
require('../../01.atoms/PageTitle/PageTitle.js');
require('../../01.atoms/Pagination/Pagination.js');
require('../../01.atoms/RichText/RichText.js');
require('../../01.atoms/TeaserMini/TeaserMini.js');
require('../../01.atoms/Textarea/Textarea.js');
require('../../01.atoms/YoutubeEmbed/YoutubeEmbed.js');
var Image = require('../Image/Image.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-checkbox-icon',
    cnDisabled = "".concat(CLASSNAME, "--disabled"),
    cnBig = "".concat(CLASSNAME, "--big"),
    cnLabel = "".concat(CLASSNAME, "__label"),
    cnCheckbox = "".concat(CLASSNAME, "__checkbox"),
    cnWrapper = "".concat(CLASSNAME, "__wrapper"),
    cnBackground = "".concat(CLASSNAME, "__background"),
    cnOverlay = "".concat(CLASSNAME, "__overlay"),
    cnIcon = "".concat(CLASSNAME, "__icon"),
    cnIconCheck = "".concat(CLASSNAME, "__icon-check"),
    cnCustomCheck = "".concat(CLASSNAME, "__custom-check"),
    cnIconCategory = "".concat(CLASSNAME, "__icon-category"),
    cnCustomImage = "".concat(CLASSNAME, "__custom-image"),
    cnTitle = "".concat(CLASSNAME, "__title");
/**
* 
* @param {*} param0 
* @returns 
*/

function CheckboxIcon(_ref) {
  var _classNames;

  var className = _ref.className,
      customIcon = _ref.customIcon,
      defaultChecked = _ref.defaultChecked,
      disabled = _ref.disabled,
      iconId = _ref.iconId,
      iconSize = _ref.iconSize,
      name = _ref.name,
      _onChange = _ref.onChange,
      required = _ref.required,
      selected = _ref.selected,
      title = _ref.title,
      type = _ref.type,
      value = _ref.value;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(CLASSNAME, className, (_classNames = {}, _rollupPluginBabelHelpers.defineProperty(_classNames, cnDisabled, disabled), _rollupPluginBabelHelpers.defineProperty(_classNames, cnBig, customIcon), _classNames))
  }, /*#__PURE__*/React__default.createElement("label", {
    className: cnLabel
  }, /*#__PURE__*/React__default.createElement("input", {
    required: required,
    disabled: disabled,
    checked: selected,
    defaultChecked: defaultChecked,
    type: type,
    name: name,
    className: cnCheckbox,
    onChange: function onChange(e) {
      _onChange(value, e.target.checked);
    },
    value: value
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cnWrapper
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cnBackground
  }, iconId && /*#__PURE__*/React__default.createElement(Icon, {
    id: iconId,
    className: classNames(cnIcon, cnIconCategory),
    size: iconSize !== null && iconSize !== void 0 ? iconSize : 'lg'
  }), customIcon && /*#__PURE__*/React__default.createElement(Image, {
    className: cnCustomImage,
    srcset: {
      xs: customIcon,
      sm: customIcon,
      md: customIcon,
      xl: customIcon
    },
    alt: "custom icon"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: cnOverlay
  }, /*#__PURE__*/React__default.createElement(Icon, {
    className: classNames(cnIcon, cnIconCheck, _rollupPluginBabelHelpers.defineProperty({}, cnCustomCheck, customIcon)),
    id: "check",
    size: "lg"
  })), /*#__PURE__*/React__default.createElement(MaterialDrop, null), /*#__PURE__*/React__default.createElement("span", {
    className: classNames(cnTitle),
    dangerouslySetInnerHTML: {
      __html: title
    }
  }))));
}
CheckboxIcon.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** Path to a custom svg icon */
  customIcon: PropTypes.string,

  /** True if is initially checked */
  defaultChecked: PropTypes.bool,

  /** True if disabled */
  disabled: PropTypes.bool,

  /** Id of icon */
  iconId: PropTypes.string,

  /** Size of icon */
  iconSize: PropTypes.oneOf(['xxs', 'xs', 'sm', 'md', 'lg', 'xl']),

  /** Name in form */
  name: PropTypes.string,

  /** Callback function onChange */
  onChange: PropTypes.func,

  /** True if required in form */
  required: PropTypes.bool,

  /** Boolean to control selected status of button */
  selected: PropTypes.bool,

  /** Title of icon button */
  title: PropTypes.string.isRequired,

  /** Type of checkbox */
  type: PropTypes.string,

  /** Value of button in form */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};
CheckboxIcon.defaultProps = {
  onChange: function onChange() {
    return void 0;
  },
  type: 'checkbox'
};

module.exports = CheckboxIcon;
